import PiConnectionService from 'app/admin/piConnection/service/PiConnectionService';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import PiAfEventReaderEditService from '../service/PiAfEventReaderEditService';

const config = () => ({
	key: 'piAfEventReaderEditForm',
	text: 'PI AF Event Reader',
	topic: 'piAfEventReader',
	service: PiAfEventReaderEditService,
	fields: () => [
		{
			key: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'piConnection',
			component: EditFormSelectField,
			required: true,
			items: () => PiConnectionService.getListSelection()
		},
		{
			key: 'database',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'templateName',
			component: EditFormTextField,
			required: true
		}
	]
});

function PiAfEventReaderEditForm() {
	const { id } = useParams();
	return <EditFormPage config={config({ id })} />;
}

export default withRouter(PiAfEventReaderEditForm);
